import { DocumentReference, DocumentData } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import {
  ProductAdvancedSettingsBuilder,
  ProductSharedSettingsBuilder,
  ProductScheduleSettingsBuilder,
  ProductInventorySettingsBuilder
} from "./builders";
import { CalendarEvent, BasicQuestion } from "..";
import { Product } from "./product";
import { ProductType, ScheduleType } from "./enums";

export class ProductBuilder {
  public reference: DocumentReference;
  public venue: DocumentReference;
  public shared: ProductSharedSettingsBuilder;
  public advanced: ProductAdvancedSettingsBuilder;
  public schedule: ProductScheduleSettingsBuilder;
  public inventory: ProductInventorySettingsBuilder;

  public events$: Observable<CalendarEvent[]>;
  public events: CalendarEvent[];
  constructor() {
    this.shared = new ProductSharedSettingsBuilder();
    this.advanced = new ProductAdvancedSettingsBuilder();
    this.schedule = new ProductScheduleSettingsBuilder();
    this.inventory = new ProductInventorySettingsBuilder();
  }

  build(): Product {
    return new Product(this);
  }

  edit(product: Product): ProductBuilder {
    this.reference = product.reference;
    this.venue = product.venue;
    this.events$ = product.events$;
    this.events = product.events;

    this.shared.edit(product.shared);
    this.schedule.edit(product.schedule);
    this.inventory.edit(product.inventory);
    this.advanced.edit(product.advanced);
    return this;
  }

  load(
    data: DocumentData,
    reference: DocumentReference,
    venue: DocumentReference
  ): ProductBuilder {
    this.reference = reference;
    this.venue = venue;
    this.shared.load(data.shared);
    this.schedule.load(data.schedule);
    this.inventory.load(data.inventory);
    this.advanced.load(data.advanced);
    return this;
  }
  setVenue(venue: DocumentReference): ProductBuilder {
    this.venue = venue;
    return this;
  }

  observe(events$: Observable<CalendarEvent[]>) {
    this.events$ = events$;
    return this;
  }

  get isActive(): boolean {
    return this.shared.isActive;
  }

  get name(): string {
    return this.shared.name;
  }

  get description(): string {
    return this.shared.description;
  }

  get instructions(): string {
    return this.shared.instructions;
  }

  get productType(): ProductType {
    return this.shared.type;
  }

  get serviceFee(): number {
    return this.shared.serviceFee;
  }

  get tips(): number[] {
    return this.shared.tips;
  }

  get warning(): string {
    return this.shared.warning;
  }

  get questions() {
    return this.shared.questions;
  }

  get productTypeMask(): string {
    return ProductType[this.productType];
  }

  get scheduleTypeMask(): string {
    return ScheduleType[this.scheduleType];
  }

  setName(name: string): ProductBuilder {
    this.shared.name = name;
    return this;
  }

  setDescription(description: string): ProductBuilder {
    this.shared.description = description;
    return this;
  }

  setVisibility(isActive: boolean): ProductBuilder {
    this.shared.isActive = isActive;
    return this;
  }

  setInstructions(instructions: string): ProductBuilder {
    this.shared.instructions = instructions;
    return this;
  }

  setProductType(type: ProductType): ProductBuilder {
    this.shared.type = type;
    console.log(this.shared.type);
    return this;
  }

  setWarning(warning: string): ProductBuilder {
    this.shared.warning = warning;
    return this;
  }

  addServiceFee(serviceFee: number): ProductBuilder {
    this.shared.serviceFee = serviceFee;
    return this;
  }
  removeServiceFee(): ProductBuilder {
    this.shared.serviceFee = null;
    return this;
  }

  addTips(t1: number, t2: number, t3: number): ProductBuilder {
    this.shared.tips = [t1, t2, t3];
    return this;
  }
  removeTips(): ProductBuilder {
    this.shared.tips = null;
    return this;
  }

  initQuestions(): ProductBuilder {
    this.shared.questions = [];
    return this;
  }
  setQuestions(questions: BasicQuestion[]): ProductBuilder {
    this.shared.questions = questions;
    return this;
  }

  addQuestion(question: BasicQuestion): ProductBuilder {
    this.shared.questions.push(question);
    return this;
  }

  setScheduleType(schedule: ScheduleType): ProductBuilder {
    this.schedule.type = schedule;
    return this;
  }
  get scheduleType(): ScheduleType {
    return this.schedule.type;
  }
}
